export default {
  meta: {
    title: '场地详情',
    url: '/car/shopfilter', // 埋点用，记录所属模块
    parentPath: ['/car/shopfilter'],
    breadcrumbs: {
      path: ['/car/shopfilter'],
      name: ['商场初筛'],
    },
  },

};
